const normalizePath = (pathname: string) => {
  const pathWithoutQuery = pathname.split("?")[0].split("#")[0] || "/";
  return pathWithoutQuery.endsWith("/")
    ? pathWithoutQuery
    : `${pathWithoutQuery}/`;
};

/** Wave 2 VTCT money course URLs using the shared course template. */
export const VTCT_MONEY_COURSE_PATHS = [
  "/courses/vtct/laser-hair-removal/",
  "/courses/vtct/level-7-diploma-in-non-surgical-aesthetic-injectable-procedures/",
  "/courses/vtct/level-7-certificate-in-non-surgical-aesthetic-injectable-procedures/",
  "/courses/vtct/level-4-certificate-in-advanced-aesthetic-therapies-for-skin/",
  "/courses/vtct/level-3-certificate-in-access-to-aesthetic-therapies/",
  "/courses/vtct/level-5-certificate-in-non-surgical-aesthetic-procedures-for-skin/",
  "/courses/vtct/level-5-certificate-in-laser-tattoo-removal/",
] as const;

export type VtctMoneyCoursePath = (typeof VTCT_MONEY_COURSE_PATHS)[number];

export function isVtctMoneyCoursePath(pathname?: string | null): boolean {
  if (!pathname) {
    return false;
  }

  return VTCT_MONEY_COURSE_PATHS.includes(
    normalizePath(pathname) as VtctMoneyCoursePath,
  );
}

export function isVtctCoursePath(pathname?: string | null): boolean {
  if (!pathname) {
    return false;
  }

  return normalizePath(pathname).startsWith("/courses/vtct/");
}

const VTCT_BREADCRUMB_LABEL_OVERRIDES: Record<string, string> = {
  "/courses/vtct/level-7-diploma-in-non-surgical-aesthetic-injectable-procedures/":
    "Level 7 Aesthetics Diploma",
};

export function getVtctCourseBreadcrumbLabel(
  pathname: string,
  pageTitle?: string | null,
): string {
  const override = VTCT_BREADCRUMB_LABEL_OVERRIDES[normalizePath(pathname)];
  if (override) {
    return override;
  }

  if (pageTitle?.trim()) {
    return pageTitle.trim();
  }

  const segment = normalizePath(pathname).split("/").filter(Boolean).pop();
  if (!segment) {
    return "Course";
  }

  return segment
    .replace(/-/g, " ")
    .replace(/\b\w/g, (char) => char.toUpperCase());
}
